import { createSelector } from '@ngrx/store';

import { SearchActionTypes, SearchActions } from 'store/actions/search.actions';
import { AppState } from '../root-reducer';

import { DatabaseSearch, ResultItem, SearchEngineTypeValue } from 'modules/shared/models/screening.models';
import { SearchValidityResponse, SearchResultResponse } from 'store/models/screening.models';

export interface State {
  quickScan: DatabaseSearch | null;
  screening: DatabaseSearch | null;
  searchResult: ResultItem | null;
  searchValidity: SearchValidityResponse | null;
  err: string | null;
  loading: Array<SearchActionTypes>;
}

const initialState: State = {
  quickScan: null,
  screening: {},
  searchResult: null,
  searchValidity: null,
  err: null,
  loading: []
};

export function reducer(state: State = initialState, action: SearchActions): State {
  switch (action.type) {
    // Get screening
    case SearchActionTypes.POST_SCREENING:
    case SearchActionTypes.GET_SCREENING: {
      return {
        ...state,
        loading: [...state.loading, action.type]
      };
    }
    case SearchActionTypes.POST_SCREENING_FAILED:
    case SearchActionTypes.POST_SCREENING_SUCCESS: {
      return {
        ...state,
        loading: clearLoading(state, SearchActionTypes.POST_SCREENING)
      };
    }
    case SearchActionTypes.GET_SCREENING_SUCCESS: {
      const newScreening = {};
      Object.keys(action.payload).map((key: string) => {
        if (action.payload[key]) {
          newScreening[key] = action.payload[key];
        }
      });
      return {
        ...state,
        screening: {
          ...state.screening,
          ...newScreening
        },
        loading: clearLoading(state, SearchActionTypes.GET_SCREENING)
      };
    }

    case SearchActionTypes.GET_SCREENING_FAILED: {
      return {
        ...state,
        err: action.payload,
        loading: clearLoading(state, SearchActionTypes.GET_SCREENING)
      };
    }
    // Get specific screening
    case SearchActionTypes.GET_SPECIFIC_SCREENING: {
      return {
        ...state,
        loading: [...state.loading, action.type]
      };
    }

    case SearchActionTypes.GET_SPECIFIC_SCREENING_FAILED: {
      return {
        ...state,
        err: action.payload,
        loading: clearLoading(state, SearchActionTypes.GET_SPECIFIC_SCREENING)
      };
    }
    case SearchActionTypes.GET_SPECIFIC_SCREENING_SUCCESS: {
      return {
        ...state,
        screening: {
          ...state.screening,
          ...action.payload
        },
        loading: clearLoading(state, SearchActionTypes.GET_SPECIFIC_SCREENING)
      };
    }
    // Patch search result
    case SearchActionTypes.PATCH_SEARCH_RESULT: {
      return {
        ...state,
        loading: [...state.loading, action.type]
      };
    }

    case SearchActionTypes.PATCH_SEARCH_RESULT_SUCCESS: {
      return {
        ...state,
        searchResult: action.payload,
        loading: clearLoading(state, SearchActionTypes.PATCH_SEARCH_RESULT)
      };
    }

    case SearchActionTypes.PATCH_SEARCH_RESULT_FAILED: {
      return {
        ...state,
        err: action.payload,
        loading: clearLoading(state, SearchActionTypes.PATCH_SEARCH_RESULT)
      };
    }

    case SearchActionTypes.GET_SEARCH_VALIDITY: {
      return {
        ...state,
        loading: [...state.loading, action.type]
      };
    }

    case SearchActionTypes.GET_SEARCH_VALIDITY_SUCCESS: {
      return {
        ...state,
        searchValidity: action.payload,
        loading: clearLoading(state, SearchActionTypes.GET_SEARCH_VALIDITY)
      };
    }

    case SearchActionTypes.GET_SEARCH_VALIDITY_FAILURE: {
      return {
        ...state,
        searchValidity: null,
        err: action.payload,
        loading: clearLoading(state, SearchActionTypes.GET_SEARCH_VALIDITY)
      };
    }

    default: {
      return state;
    }
  }
}

const searches = (state: AppState) => state.search;
export const Selectors = {
  err: createSelector(searches, (state: State) => state.err),
  screening: createSelector(searches, (state: State) => state.screening),
  isCurrentScreeningDone: (forEngines: SearchEngineTypeValue[]) => createSelector(searches, (state: State) => {
    let isSeachDone: boolean = true;
    Object.keys(<SearchResultResponse>state.screening)
      .forEach((engine: string) => {
        if (forEngines
          .map((searchEngine: SearchEngineTypeValue) => searchEngine.toString())
          .indexOf(engine) >= 0 &&
          state.screening[engine] &&
          state.screening[engine].results.length > 0) {
          isSeachDone = isSeachDone && state.screening[engine].results[0].isSearchFinished;
        }
      });
    return isSeachDone;
  }),
  searchResult: createSelector(searches, (state: State) => state.searchResult),
  searchValidity: createSelector(searches, (state: State) => state.searchValidity),
  getLoading: createSelector(searches, (state: State) => state.loading)
};

function clearLoading(authState: State, action: SearchActionTypes): Array<SearchActionTypes> {
  return authState.loading.filter((loadingMarker: SearchActionTypes) => loadingMarker !== action);
}
